import React from 'react';
import PropTypes from 'prop-types';
import './Button.scss';
import useTheme from '../../hooks/useTheme';

const Button = ({
	Icon = null,
	iconSize = '16px',
	align = 'left',
	disabled = false,
	label,
	type,
	onClick,
	width = '77px',
	height = '32px',
	style = {},
	className = '',
}) => {
	const getButtonTypeClass = () => {
		switch (type) {
			case 'primary':
				return 'primary';
			case 'primary_hover':
				return 'primary_hover';
			case 'primary_pressed':
				return 'primary_pressed';
			case 'outline':
				return 'outline';
			case 'outline_hover':
				return 'outline_hover';
			case 'outline_pressed':
				return 'outline_pressed';
			case 'secondary':
				return 'secondary';
			case 'secondary_hover':
				return 'secondary_hover';
			case 'secondary_pressed':
				return 'secondary_pressed';
			case 'tertiary':
				return 'tertiary';
			case 'tertiary_hover':
				return 'tertiary_hover';
			case 'tertiary_pressed':
				return 'tertiary_pressed';
			default:
				return '';
		}
	};
	const getButtonBackgroundClass = (hover) => {
		console.log('type===',hover, "---", type + hover)
		switch (type + hover) {
			case 'primary':
				return color.button.primary;
			case 'primary_hover':
				return color.button.primary_hover;
			case 'primary_pressed':
				return color.button.primary_pressed;
			case 'outline':
				return color.button.outline;
			case 'outline_hover':
				return color.button.outline_hover;
			case 'outline_pressed':
				return color.button.outline_pressed;
			case 'secondary':
				return color.button.secondary;
			case 'secondary_hover':
				return color.button.secondary_hover;
			case 'secondary_pressed':
				return color.button.secondary_pressed;
			case 'tertiary':
				return color.background.primary;
			case 'tertiary_hover':
				return color.button.secondary_outline_hover;
			case 'tertiary_pressed':
				return color.button.secondary_outline_pressed;
			default:
				return '';
		}
	};
	const getButtonTextColor = (hover) => {
		switch (type+hover) {
			case 'primary':
				return color.button.primary_text;
			case 'primary_hover':
				return color.button.primary_text;
			case 'primary_pressed':
				return color.button.primary_text;
			case 'outline':
				return color.button.primary_outline_text;
			case 'outline_hover':
				return color.button.primary_outline_text;
			case 'outline_pressed':
				return color.button.primary_outline_text;
			case 'secondary':
				return color.button.secondary_text;
			case 'secondary_hover':
				return color.button.secondary_text;
			case 'secondary_pressed':
				return color.button.secondary_text;
			case 'tertiary':
				return color.button.tertiary_text;
			case 'tertiary_hover':
				return color.button.primary;
			case 'tertiary_pressed':
				return color.button.primary_hover;
			default:
				return color.button.secondary_text;
		}
	};
	const combinedClassName = `${className} generic-button ${getButtonTypeClass()}`;
	const { color, FontFace } = useTheme('LIGHT');
	const [dynamicBackgroundColor, setDynamicBackgroundColor] =
		React.useState('');
	const onChangeEvent = (e, type) => {
		const dynamicBgcolor = getButtonBackgroundClass(type);
		e.target.style.backgroundColor = dynamicBgcolor;
		const dynamicTextcolor = getButtonTextColor(type);
		e.target.style.color = dynamicTextcolor;

		setDynamicBackgroundColor(dynamicBgcolor);
	};
	const styles = {
		backgroundColor:
			type === 'primary'
				? color.button.primary
				: type === 'primary_hover'
				? color.button.primary_hover
				: type === 'primary_pressed'
				? color.button.primary_pressed
				: type === 'outline_hover'
				? color.button.primary_outline_hover
				: type === 'outline_pressed'
				? color.button.primary_outline_pressed
				: type === 'secondary'
				? color.button.secondary
				: type === 'secondary_hover'
				? color.button.secondary_hover
				: type === 'secondary_pressed'
				? color.button.secondary_pressed
				: type === 'tertiary'
				? color.background.primary
				: type === 'tertiary_hover'
				? color.button.secondary_outline_hover
				: type === 'tertiary_pressed'
				? color.button.secondary_outline_pressed
				: color.background.primary,

		color:
			type === 'primary' ||
			type === 'primary_hover' ||
			type === 'primary_pressed'
				? color.button.primary_text
				: color.button.secondary_text,

		border:
			type === 'outline' ||
			type === 'outline_hover' ||
			type === 'outline_hover'
				? `2px solid ${color.button.primary_outline_text}`
				: 'none',

		fontSize: FontFace.font_size.input_text,
		borderRadius: '4px',
		fontWeight: FontFace.font_weight.medium,
		padding: '8px 16px',
		width: width,
		height: height,
		fontFamily: 'Inter-Medium',
		cursor: disabled ? 'not-allowed' : 'pointer',
		opacity: disabled ? 0.6 : 1,
		...style,
	};

	return (
		<button
			style={styles} // Apply dynamic styles
			className={combinedClassName}
			onClick={onClick}
			onMouseEnter={(e) => {
				onChangeEvent(e, '_hover');
			}}
			onMouseLeave={(e) => {
				onChangeEvent(e, '');
			}}
			onMouseDown={(e) => {
				onChangeEvent(e, '_pressed');
			}}
			onMouseUp={(e) => {
				onChangeEvent(e, '_hover');
			}}
			disabled={disabled}
		>
			<IconWithLabel
				Icon={Icon}
				align={align}
				label={label}
				styles={styles}
				iconSize={iconSize}
				dynamicBackgroundColor={dynamicBackgroundColor}
			/>
		</button>
	);
};

Button.propTypes = {
	label: PropTypes.string.isRequired,
	type: PropTypes.oneOf([
		'primary',
		'primary_hover',
		'primary_pressed',
		'outline',
		'outline_hover',
		'outline_pressed',
		'secondary',
		'secondary_hover',
		'secondary_pressed',
		'tertiary_hover',
		'tertiary_pressed',
		'tertiary',
	]),
	onClick: PropTypes.func,
	width: PropTypes.string,
	height: PropTypes.string,
	align: PropTypes.oneOf(['left', 'right']),
	Icon: PropTypes.object,
	iconSize: PropTypes.string,
	disabled: PropTypes.bool,
	style: PropTypes.object,
	className: PropTypes.string
};

Button.defaultProps = {
	type: 'primary',
	onClick: () => {},
	align: 'left',
	Icon: null,
	iconSize: '16px',
	disabled: false,
	style: {},
};

export default Button;

const IconWithLabel = ({
	Icon,
	align,
	label,
	styles,
	iconSize,
	dynamicBackgroundColor,
}) => {
	if (Icon !== null) {
		if (align === 'left') {
			return (
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						alignItems: 'center',
						gap: '4px',
					}}
				>
					<Icon
						className="generic-button-icon"
						fill={dynamicBackgroundColor}
						width={iconSize}
						height={iconSize}
					/>
					<div
						style={{
							fontSize: styles.fontSize,
							fontWeight: styles.fontWeight,
							fontFamily: styles.fontFamily,
							color: styles.color,
							backgroundColor: dynamicBackgroundColor,
							alignItems: 'center',
						}}
					>
						{label}
					</div>
				</div>
			);
		} else if (align === 'right') {
			return (
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						alignItems: 'center',
						gap: '4px',
					}}
				>
					<div
						style={{
							fontSize: styles.fontSize,
							fontWeight: styles.fontWeight,
							fontFamily: styles.fontFamily,
							color: styles.color,
							backgroundColor: dynamicBackgroundColor,
							alignItems: 'center',
						}}
					>
						{label}
					</div>
					<Icon
						className="generic-button-icon"
						fill={dynamicBackgroundColor}
						width={iconSize}
						height={iconSize}
					/>
				</div>
			);
		}
	}

	// Fallback: If icon is not an object or null, or if align is not 'left' or 'right'
	return label;
};

IconWithLabel.propTypes = {
	label: PropTypes.string.isRequired,
	dynamicBackgroundColor: PropTypes.string,
	styles: PropTypes.object,
	disabled: PropTypes.bool,
	align: PropTypes.oneOf(['left', 'right']),
	Icon: PropTypes.object,
	iconSize: PropTypes.string,
};
